import useSharedStepFlow from "src/hooks/useStepFlow";
import { HOTEL_DETAILS_STEPS } from "../constants";
import { useHotelDynamicDetails } from "../Pages/HotelDetails/context";

export default function useStepFlow() {
  const { validityState } = useHotelDynamicDetails();
  return useSharedStepFlow({ steps: HOTEL_DETAILS_STEPS, validityState });
}
